module.exports = __webpack_public_path__ + "static/img/126.8966d63.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/126.png
// module id = bCYg
// module chunks = 0